<template>
  <div class="coderpix_tm_topbar">
    <div class="topbar_inner">
      <div class="logo">
        <LogoComponent />
      </div>
      <div class="trigger">
        <div
          class="hamburger hamburger--slider"
          @click="navFuntions.toggleMobileMenu()"
        >
          <div class="hamburger-box">
            <div class="hamburger-inner"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div
    class="coderpix_tm_mobile_menu"
    :class="navFuntions.mobileToggle ? 'opened' : ''"
  >
    <div class="inner">
      <div class="menu_list">
        <Menu />
      </div>
    </div>
  </div>
</template>

<script>
import { navFuntions } from "@/navFuntions";
import Menu from "./Menu.vue";
import LogoComponent from "../LogoComponent.vue";

export default {
  name: `MobileHeaderComponent`,
  data() {
    return {
      navFuntions,
    };
  },
  components: { Menu, LogoComponent },
};
</script>


<style scoped>
.coderpix_tm_topbar,
.coderpix_tm_mobile_menu {
  display: none;
  z-index: 999 !important;
}
.logo {
  z-index: 1000;
  position: relative;
}
@media (max-width: 1040px) {
  .coderpix_tm_topbar,
  .coderpix_tm_mobile_menu {
    display: block;
  }
}
</style>


